export async function validateTenantExists(tenant, timeoutMs = 6000) {
    const url = `https://login.microsoftonline.com/${encodeURIComponent(tenant)}/v2.0/.well-known/openid-configuration`;
    const controller = new AbortController();
    const id = setTimeout(() => controller.abort(), timeoutMs);
    try {
        const res = await fetch(url, {
            method: 'GET',
            signal: controller.signal,
            credentials: 'omit',
            cache: 'no-store',
        });
        if (!res.ok)
            return false;
        await res.json();
        return true;
    }
    catch {
        return false;
    }
    finally {
        clearTimeout(id);
    }
}
